module.exports = __webpack_public_path__ + "static/media/bg.514b409f.png";